/**
 * Build-time feature flags.
 *
 * These are read from REACT_APP_* env vars at build time (Create React App inlines
 * them), so each deployed environment can turn a feature on or off through its own
 * env file without a code change.
 */

/**
 * MoodMate + the personal Mood Journal.
 *
 * Enabled by default (dev, local). To hide every MoodMate / Mood Journal entry point
 * in a given environment — e.g. production — set REACT_APP_ENABLE_MOODMATE=false in
 * that environment's env file (.env.prod / .env.production). Any other value, or the
 * var being unset, leaves the feature on.
 */
export const MOODMATE_ENABLED =
  process.env.REACT_APP_ENABLE_MOODMATE !== 'false';
